import { render } from "./BusinessStoreOrders.vue?vue&type=template&id=53b57398"
import script from "./BusinessStoreOrders.vue?vue&type=script&lang=js"
export * from "./BusinessStoreOrders.vue?vue&type=script&lang=js"

import "./BusinessStoreOrders.vue?vue&type=style&index=0&id=53b57398&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__